import { Component } from '@angular/core';

@Component({
  selector: 'intro-and-logo',
  templateUrl: './intro-and-logo.component.html',
  styleUrl: './intro-and-logo.component.scss'
})
export class IntroAndLogoComponent {

}
